export default "__VITE_ASSET__1d19f891__"